import { SubmissionError } from 'redux-form';
import { showError } from '../../actions/errorActions';

export const handleTakerApiError = (rejection, dispatch) => {
  if (rejection.submissionError) {
    throw new SubmissionError(rejection.submissionError);
  } else {
    dispatch(showError(rejection));
  }
  return Promise.reject(rejection);
};
